export interface Login {
    email:string,
    provinceCode:string,
    authToken:string,
}

export function defaultLoginValues(): Login {
    return <Login>{
        email:'',provinceCode:'',authToken:''
    }
}
